(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('click', function (event) {
  if (!event.target.matches('.gate-selector__submit')) return;
  event.preventDefault(); //check if inputs are valid

  var inputs = validateInputs();
  if (inputs == false) return; // Grab and Parse Product Data

  var jsonGrab = document.getElementById('json').innerHTML;
  var json = JSON.parse(jsonGrab);
  var filterJSON = Object.values(json).filter(function (entry) {
    // Check if inputed width is within the range of the product
    var acceptedWidth = false;

    if (inputs[2] == 'unset') {
      acceptedWidth = true;
    } else {
      //Split Range by comma in case there are multiple ranges (a gap in the range) and loop through each range
      for (var i = 0; i < entry.width_range.split(',').length; i++) {
        // If inputed width is greater than the first number in the range and less than the second number in the range, accept the width
        if (parseFloat(entry.width_range.split(',')[i].split('-')[0]) <= inputs[2] && parseFloat(entry.width_range.split(',')[i].split('-')[1]) >= inputs[2]) {
          acceptedWidth = true;
        }
      }
    } // Check if any of the inputed materials match with any materials in the product


    var acceptedMaterial = false;

    for (var i = 0; i < inputs[1].split('/').length; i++) {
      if (entry.material.includes(inputs[1].split('/')[i].trim())) {
        if (inputs[1].split('/')[i].trim() != '') {
          acceptedMaterial = true;
        }
      }
    } // If product matches all criteria, add to the filtered list


    return acceptedWidth == true && entry.height >= inputs[3] && entry.location.includes(inputs[0]) && acceptedMaterial == true;
  }); // show the results

  var resultsList = document.getElementById("results");

  if (filterJSON.length == 0) {
    document.getElementById('gate-selector-form').style.display = 'none';
    document.querySelector('.gate-selector-results').style.display = 'block';
    document.getElementById('no-results-message').style.display = 'block';
    document.querySelector('.gate-selector-results').scrollIntoView({
      block: "start"
    });
  } else {
    filterJSON.forEach(function (item) {
      var resultItem = '<li><a class="gate-selector-results__item" href="' + item.url + '"><img class="gate-selector-results__img" src="' + item.image + '" alt="' + item.title + '"><h3 class="title--quaternary gate-selector-results__title">' + item.title + '</h3></li>'; // create a new card
      // populate the card
      // append the card to the results

      resultsList.insertAdjacentHTML('beforeend', resultItem);
    });
    document.getElementById('gate-selector-form').style.display = 'none';
    document.querySelector('.gate-selector-results').style.display = 'block';
    document.querySelector('.gate-selector-results').scrollIntoView({
      block: "start"
    });
  }
}); // Start Over code to reset list and show form

document.addEventListener('click', function (event) {
  if (!event.target.matches('#start-over')) return;
  event.preventDefault();
  document.getElementById('gate-selector-form').reset();
  document.getElementById('gate-selector-form').style.display = 'block';
  document.querySelector('.gate-selector-results').style.display = 'none';
  document.getElementById('no-results-message').style.display = 'none';
  document.querySelector('.gate-selector-results__list').innerHTML = '';
}); //reset error on input

document.addEventListener('click', function (event) {
  if (!event.target.matches('input[name="location"]')) return;

  if (document.querySelector('.gate-selector__location-error').innerHTML != '') {
    document.querySelector('.gate-selector__location-error').innerHTML = '';
  }
});

function validateInputs() {
  var selectedLocation = '';

  if (document.querySelector('input[name="location"]:checked') == null) {
    document.querySelector('.gate-selector__location-error').innerHTML = 'Input required';
    document.querySelector('.gate-selector__location-error').scrollIntoView({
      block: "start"
    });
    return false;
  } else {
    for (var i = 0; i < document.querySelectorAll('input[name="location"]:checked').length; i++) {
      selectedLocation += document.querySelectorAll('input[name="location"]:checked')[i].value + '/';
    }
  }

  var selectedLocation = document.querySelector('input[name="location"]:checked').value;
  var selectedMaterial = ''; // if no material is selected, default to all materials, else loop through selected materials and add to string

  if (document.querySelector('input[name="material"]:checked') == null) {
    selectedMaterial = 'wood/steel/plastic';
  } else {
    for (var i = 0; i < document.querySelectorAll('input[name="material"]:checked').length; i++) {
      selectedMaterial += document.querySelectorAll('input[name="material"]:checked')[i].value + '/';
    }
  }

  var width = document.querySelector('input[name="width"]').value;
  var height = document.querySelector('input[name="height"]').value; //if width not inputted ~ set to 'unset'

  if (width == '') {
    width = 'unset';
  } //if height not inputted ~ set minimum to 0


  if (height == '') {
    height = 0;
  }

  return [selectedLocation, selectedMaterial, width, height];
}

},{}]},{},[1]);
